<template>
  <div class="flex flex-col gap-1">
    <p ref="content" :class="[ 'm-0 whitespace-pre-line [overflow-wrap:anywhere]', isActive ? '' : 'line-clamp-3' ]">{{ text }}</p>
    <button
      v-if="isOverflowing || isActive"
      type="button"
      data-slot="read-more"
      class="ml-auto w-fit cursor-pointer text-sm font-semibold text-primary hover:underline"
      @click="() => toggle()"
    >
      {{ isActive ? tr('Close') : tr('Read more') }}
    </button>
  </div>
</template>

<script>
/** Plain text clamped to three lines with a read more / close toggle. */
export default {
  name: 'ReadMoreText',
  props: {
    text: {
      type: [ String, null ],
      required: false,
      default: () => null,
    },
  },
  data: () => ({
    isActive: false,
    isOverflowing: false,
  }),
  watch: {
    text() {
      this.$nextTick(() => this.checkOverflow());
    },
  },
  mounted() {
    this.$nextTick(() => this.checkOverflow());
    window.addEventListener('resize', this.checkOverflow);
  },
  beforeUnmount() {
    window.removeEventListener('resize', this.checkOverflow);
  },
  methods: {
    checkOverflow() {
      if (this.isActive) {
        return;
      }

      const el = this.$refs.content;
      if (!el) {
        return;
      }

      this.isOverflowing = el.scrollHeight > el.clientHeight + 1;
    },
    toggle() {
      this.isActive = !this.isActive;

      if (!this.isActive) {
        this.$nextTick(() => this.checkOverflow());
      }
    },
  },
};
</script>
